import React from 'react'
import gql from 'graphql-tag'
import RouteAdminFeaturesGlobalIndexQuery from 'routes/admin/features/global/index.query'
import { Mutation } from 'react-apollo'

const DELETE_FEATURE = gql`
  mutation DeleteFeatureMutation($input: DeleteFeatureInput!) {
    deleteFeature(input: $input) {
      features {
        id
        name
        enabled
      }
      viewer {
        id
        ... on User {
          features
        }
      }
    }
  }
`

const DeleteFeatureMutation = ({ children, feature }) => (
  <Mutation mutation={DELETE_FEATURE}>
    {(mutation, props) =>
      children({
        ...props,
        deleteFeature: () =>
          mutation({
            variables: { input: { name: feature.name } },
            update: (
              cache,
              {
                data: {
                  deleteFeature: { features }
                }
              }
            ) => {
              cache.writeQuery({
                query: RouteAdminFeaturesGlobalIndexQuery,
                data: { features }
              })
            }
          })
      })
    }
  </Mutation>
)

export default DeleteFeatureMutation



// WEBPACK FOOTER //
// ./src/components/mutations/DeleteFeature.js